module.exports = {"id":"177790","name":"Artur Jędrzejczyk","rating":"72","photo":"./data/images/photos/2/177790.png","club":{"name":"Legia Varsovie","logo":"./data/images/clubs/LegiaVarsovie.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArturJedrzejczyk0.json
// module id = 481
// module chunks = 0